var map = {
	"./whats-new1.22.0/WhatsNew.json": 607568,
	"./whats-new1.23.0/WhatsNew.json": 773469,
	"./whats-new1.30.0/WhatsNew.json": 895025,
	"./whats-new1.39.0/WhatsNew.json": 442316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76930;